import { render } from "./AfternoonDecoratorComponent.vue?vue&type=template&id=730b074c&scoped=true"
import script from "./AfternoonDecoratorComponent.vue?vue&type=script&lang=js"
export * from "./AfternoonDecoratorComponent.vue?vue&type=script&lang=js"

import "./AfternoonDecoratorComponent.vue?vue&type=style&index=0&id=730b074c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730b074c"]])

export default __exports__